import { AuthorizedS3TransferMedium } from "@studyportals/client-internal-platform-aws-authorization";

// TODO: CITA-21945 - Can clean this up once we replaced this with either GZIP or other solution.
export class OptimizedAuthorizedS3TransferMedium<TPayload> extends AuthorizedS3TransferMedium<TPayload> {
	public async unpack(identifier: string): Promise<TPayload> {
		const serializedPayload = await this.s3Adapter.getJSON(identifier);
		const payload = this.deserialize(serializedPayload);

		void this.s3Adapter.delete(identifier);

		return payload;
	}
}
